import url from './url';



export default url(({ notificationId = ':notificationId' }) => `/local-notifications/${notificationId}/edit`);
